import { BaseDto } from '../base.dto';
import { IsInt, IsOptional, IsString, Length, Matches } from 'class-validator';
import { Exclude } from 'class-transformer';
import { validationPatterns } from '../../constants';

export class BankingCompVoidRefundApprovalUpdateDto extends BaseDto {
  @Exclude()
  orderId: number;

  @Exclude()
  orderPosTableProductId: number;

  @IsOptional()
  @IsString()
  @Length(0, 255)
  @Matches(validationPatterns.noteValidation)
  description:string;

  @IsOptional()
  @IsInt()
  compRefundCategoryId: number;

  @IsOptional()
  @IsInt()
  approvedUserId: number;

  @IsOptional()
  @IsInt()
  approvedEmployeeId: number;
}
